import { Spinner } from "components";
import { CustomerClosedChart } from "components/charts";
import { ChartLayout } from "layouts";
import { useState, useEffect } from "react";

function CustomerClosed({
  landlordsData = { categories: [], data: [], loading: false, error: null },
  setDateRange,
}) {
  const { categories = [], data = [], loading, error } = landlordsData;
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    if (loading) {
      setFadeIn(false);
    } else {
      const timer = setTimeout(() => {
        setFadeIn(true);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [loading]);

  return (
    <ChartLayout title="New sign ups" isDateFilter={true} setDate={setDateRange}>
      {loading ? (
        <div className="flex flex-col items-center justify-center h-full p-4 min-h-96 transition-opacity duration-300 ease-in-out">
          <div className="animate-pulse">
            <Spinner size="large" color="#19a8a6" />
          </div>
        </div>
      ) : error ? (
        <div className="flex items-center justify-center h-full transition-opacity duration-300 ease-in-out">
          <div className="text-red-500">Error loading status data</div>
        </div>
      ) : (
        <div
          className={`w-full flex-1 flex flex-col py-4 transition-opacity duration-300 ease-in-out ${
            fadeIn ? "opacity-100" : "opacity-0"
          }`}
        >
          <CustomerClosedChart
            labels={categories}
            series={data}
            key={`status-chart-${JSON.stringify(categories)}-${JSON.stringify(
              data
            )}`}
          />
        </div>
      )}
    </ChartLayout>
  );
}
export default CustomerClosed;
